import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    tbId = 0,
    fields = [],
    data = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(`${URLS.das.utableData.importData}/${tbId}`, {
        fields,
        data,
    }, options);
    if (error) return { error, status };
    return content || {};
};
